module.exports = __webpack_public_path__ + "assets/imgs/logos/appsflyer.8f482b557a895f162962b481a720c86d.png";